import React from "react";
import {t} from "../../../../../../../../../components/Translate";
import {updateAiType} from "../../../../../../../../../services/company/api";
import config from "../../../../../../../../../config";
import DropdownSelect from "../../../../../../../../../components-new/form/DropdownSelect";
import AiBlock from "./AiBlock";
import AiTypeIcon from "./AiTypeIcon";

const AiTypeSelector = ({client, aiType, setAiType, user, features, addNotification}) => {

    function handleChange(e) {
        var value = e.value;

        updateAiType(client.id, value)
            .then(function () {
                setAiType(value);
                addNotification("successful", config.notificationLevels.success);
            })
            .catch(function () {
                addNotification("somethingWentWrong", config.notificationLevels.error);
            });
    }

    const options = [
        {value: "null", label: t({text: "notSelected", user})},
        ...(features.includes(config.features.GPT_AI)
            ? [{value: config.AITypes.GPT_AI, label: t({text: config.AITypes.GPT_AI, user})}]
            : []),
        ...(features.includes(config.features.GEMINI_AI)
            ? [{value: config.AITypes.GEMINI_AI, label: t({text: config.AITypes.GEMINI_AI, user})}]
            : []),
        ...(features.includes(config.features.TEAM_AI)
            ? [{value: config.AITypes.TEAM_AI, label: t({text: config.AITypes.TEAM_AI, user})}]
            : []),
        ...(features.includes(config.features.TEAM_AI) ?
            [{value:config.AITypes.TEAM_AI_TEST, label:t({ text: config.AITypes.TEAM_AI_TEST, user })}]
            : [])
    ];

    const renderOption = (option) => (
        <span className="ai-type-option">
            <AiTypeIcon type={option && option.value} size={18}/>
            <span>{option && option.label}</span>
        </span>
    );

    return (
        <AiBlock titleKey="aiType" primary>
            {/*
                The provider's mark beside its name. Four options, three of them
                ending in "AI", are told apart by reading; a logo is recognised
                without it - and once one is chosen the trigger says at a glance
                whose model this bot is running on.
            */}
            <DropdownSelect
                selectedValue={options.find(option => option.value === aiType) ? options.find(option => option.value === aiType) : options[0]}
                onChange={handleChange}
                options={options}
                renderLabel={renderOption}
                variant={'outline'}
                styles={{width: '100%'}}
            >
                {(option) => renderOption(option)}
            </DropdownSelect>
        </AiBlock>
    );
};

export default AiTypeSelector;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/AI/AiTypeSelector.jsx